$(function() {
  $('.overlay-toggle-link').on('click', function(jqEvent) {
    jqEvent.preventDefault();
    let toggle_id = '#' + $(this).data('toggle');
    let popup_x = $(jqEvent.target).position().left + $(jqEvent.target).width();
    let popup_y = $(jqEvent.target).position().top;
    $(toggle_id).css("top", popup_y + "px").css("left", popup_x + "px").fadeToggle(75);
  });

  // For vendor edit button
  $('.vendor-links').on('click', () => {
    return false;
  });

  const loadAjax = (link, type, data) => {
    let group = link.parent();
    $.ajax({
      url: link.data('url'),
      type: type,
      dataType: 'text',
      data: data,
      success: (response) => {
        $('#' + group.data('target')).html(response);
        $('.' + group.data('group')).each(function() {
          let button = $(this);
          button.toggle();
          if (button.is(':visible')) {
            button.css({'display': 'inline-block'});
          }
        });
      },
      error: (xhr, status, msg) => {
        console.log([status, msg].join(' : '));
      }
    });
  };

  $('.edit-link, .cancel-link').on('click', function() {
    loadAjax($(this), 'GET', '');
  });

  $('.save-link').on('click', function() {
    loadAjax($(this), 'PUT', $('#' + $(this).data('form-id')).serialize());
  });
});